import { SWRConfig } from "swr";

import OrganizationDetails from "@/src/components/organizations/OrganizationDetails";
import { OrganizationDetailsBlogTab } from "@/src/views/organizations/OrganizationDetailsPage";

export { getServerSideProps } from "../[username]";

export default function OrganizationBlogPage(context) {
  const { fallback, username } = context;

  const tabRoutes = [
    { url: `/organizations/${username}/`, name: "About" },
    { url: `/organizations/${username}/blog/`, name: "Blog", isActive: true },
    { url: `/organizations/${username}/get-involved`, name: "Get Involved" },
  ];

  return (
    <SWRConfig value={{ fallback }}>
      <section className="section">
        <OrganizationDetails username={username} tabRoutes={tabRoutes}>
          <OrganizationDetailsBlogTab username={username} />
        </OrganizationDetails>
      </section>
    </SWRConfig>
  );
}
